import styled from "@emotion/styled";

export const PlusIcon = styled.div`
  position: relative;
  height: 50px;
  width: 50px;
  &:before,
  &:after {
    content: "";
    height: 4px;
    width: 100%;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    margin-top: -2px;
    left: 0;
    right: 0;
    background: currentColor;
  }
  &:after {
    transform: rotate(90deg);
  }
`;
